import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthServiceLocal } from 'src/@order/services/auth.service';
declare var lottie: any;

@Component({
  selector: 'app-inter-regional-payment-success',
  templateUrl: './inter-regional-payment-success.component.html',
  styleUrls: ['./inter-regional-payment-success.component.scss']
})

export class InterRegionalPaymentSuccessComponent implements OnInit, AfterViewInit, OnDestroy {

  orderNumber: string = '';
  orderId: string = '';
  expectedDelivery: string = '';

  getInterOrderDetailRoute(): string {
    const country = localStorage.getItem('country');
    return country === 'Ghana' ? '/orders/inter-regional-detail/' : '/orders/inter-state-detail/';
  }

  constructor(
    private _authService: AuthServiceLocal,
    private _router: Router

  ) { }

  ngOnInit(): void {
    this.fetchOrderDataFromLocal();
  }

  private fetchOrderDataFromLocal(): void {
    try {
      const orderData = JSON.parse(localStorage.getItem('PENDINGINTERREGIONALORDERDATA') || '{}');

      console.log('orderData', orderData.orderData.data);

      if (orderData?.orderData?.data) {

        this.orderNumber = orderData.orderData.data.order_number
        this.expectedDelivery = orderData.orderData.data.expectedDeliveryTime
        this.orderId = orderData.orderData.data.id

        console.log('Order data fetched from localStorage:', {
          orderNumber: this.orderNumber,
          expectedDelivery: this.expectedDelivery
        });
      } else {
        console.log('No order data found in localStorage, using default values');

      }
    } catch (error) {
      console.error('Error parsing order data from localStorage:', error);

    }
  }

  ngAfterViewInit() {
    lottie.loadAnimation({
      container: document.getElementById('success-lottie'), // Your container ID
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'assets/Success.json', // Relative path to your animation file
    });
  }

  downloadWaybill(): void {
    console.log('Downloading waybill for order:', this.orderId);

    const data = {
      interRegionalOrderId: this.orderId
    }

    this._authService.downloadWaybill(data).subscribe((res: any) => {
      console.log('Waybill downloaded successfully:', res);
      window.open(res.data, '_blank');
    });
  }

  viewOrderDetail(): void {

    console.log('Navigating to order detail for:', this.orderNumber);
    this._router.navigate([this.getInterOrderDetailRoute() + this.orderId]);

  }

  ngOnDestroy(): void {
    localStorage.removeItem('PENDINGINTERREGIONALORDERDATA');
  }
}
